import { FullInfoResponse } from 'react-easyrocket';

export const getChangedProfileData = (
  dataToProfile: Record<string, string | undefined>,
  fullInfo: FullInfoResponse
): Record<string, string> => {
  return Object.entries(dataToProfile).reduce((acc, [key, value]) => {
    if (key === 'code' && value) {
      if (fullInfo.phone?.code !== value) {
        acc[key] = value;
      }
    } else if (key === 'phone' && value) {
      if (fullInfo.phone?.number !== value) {
        acc[key] = value;
      }
    } else if (key in fullInfo && value && fullInfo[key as keyof typeof fullInfo] !== value) {
      acc[key] = value;
    }
    return acc;
  }, {} as Record<string, string>);
};
